// Amounts in Urdu words, for a figure that should be read as well as seen: "Rs 67,829,609" is
// easy to misread by a digit, "چھ کروڑ اٹھہتر لاکھ انتیس ہزار چھ سو نو روپے" is not.
//
// Grouped the way Pakistan counts: ارب (100 crore), کروڑ (100 lakh), لاکھ (100 thousand), ہزار,
// سو. Every number below a hundred has its own word in Urdu, so they are listed, not built.

const UNDER_HUNDRED = [
  'صفر', 'ایک', 'دو', 'تین', 'چار', 'پانچ', 'چھ', 'سات', 'آٹھ', 'نو',
  'دس', 'گیارہ', 'بارہ', 'تیرہ', 'چودہ', 'پندرہ', 'سولہ', 'سترہ', 'اٹھارہ', 'انیس',
  'بیس', 'اکیس', 'بائیس', 'تئیس', 'چوبیس', 'پچیس', 'چھبیس', 'ستائیس', 'اٹھائیس', 'انتیس',
  'تیس', 'اکتیس', 'بتیس', 'تینتیس', 'چونتیس', 'پینتیس', 'چھتیس', 'سینتیس', 'اڑتیس', 'انتالیس',
  'چالیس', 'اکتالیس', 'بیالیس', 'تینتالیس', 'چوالیس', 'پینتالیس', 'چھیالیس', 'سینتالیس', 'اڑتالیس', 'انچاس',
  'پچاس', 'اکاون', 'باون', 'ترپن', 'چون', 'پچپن', 'چھپن', 'ستاون', 'اٹھاون', 'انسٹھ',
  'ساٹھ', 'اکسٹھ', 'باسٹھ', 'ترسٹھ', 'چونسٹھ', 'پینسٹھ', 'چھیاسٹھ', 'سڑسٹھ', 'اڑسٹھ', 'انہتر',
  'ستر', 'اکہتر', 'بہتر', 'تہتر', 'چوہتر', 'پچہتر', 'چھہتر', 'ستتر', 'اٹھہتر', 'اناسی',
  'اسی', 'اکیاسی', 'بیاسی', 'تراسی', 'چوراسی', 'پچاسی', 'چھیاسی', 'ستاسی', 'اٹھاسی', 'نواسی',
  'نوے', 'اکانوے', 'بانوے', 'ترانوے', 'چورانوے', 'پچانوے', 'چھیانوے', 'ستانوے', 'اٹھانوے', 'ننانوے',
];

// Largest first. Above an arab the count is itself said in words ("سو ارب"), which covers any
// amount this app will see.
const SCALES = [
  { value: 1e9, word: 'ارب' },
  { value: 1e7, word: 'کروڑ' },
  { value: 1e5, word: 'لاکھ' },
  { value: 1e3, word: 'ہزار' },
  { value: 100, word: 'سو' },
];

const wordsFor = (n) => {
  if (n < 100) return n === 0 ? '' : UNDER_HUNDRED[n];
  const parts = [];
  let rest = n;
  SCALES.forEach(({ value, word }) => {
    const count = Math.floor(rest / value);
    if (count > 0) {
      parts.push(`${wordsFor(count)} ${word}`);
      rest -= count * value;
    }
  });
  if (rest > 0) parts.push(UNDER_HUNDRED[rest]);
  return parts.join(' ');
};

/** A whole number in Urdu words: 1250 reads "ایک ہزار دو سو پچاس". Rounds; a negative starts منفی. */
export const numberInUrduWords = (value) => {
  const n = Math.round(Number(value));
  if (!Number.isFinite(n)) return '';
  if (n === 0) return UNDER_HUNDRED[0];
  return `${n < 0 ? 'منفی ' : ''}${wordsFor(Math.abs(n))}`;
};

/** Rupees in Urdu words, to the whole rupee: "ایک روپیہ", "چھ کروڑ ... نو روپے". */
export const rupeesInUrduWords = (value) => {
  const words = numberInUrduWords(value);
  if (!words) return '';
  return `${words} ${Math.abs(Math.round(Number(value))) === 1 ? 'روپیہ' : 'روپے'}`;
};
